import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslocoModule } from '@jsverse/transloco';
import { AuthAppRedirectService } from '@services/auth-app-redirect.service';
import { TuiButton, TuiTitle } from '@taiga-ui/core';
import { ContactUsService } from 'src/app/services/contact-us.service';

@Component({
  selector: 'pxc-disabled-account',
  imports: [TuiButton, TuiTitle, TranslocoModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './disabled-account.component.html',
})
export class DisabledAccountComponent {
  private readonly contactUsService = inject(ContactUsService);
  private readonly authAppRedirectService = inject(AuthAppRedirectService);

  openContactUsForm(): void {
    this.contactUsService.openPixacareSupportForm();
  }

  logout(): void {
    this.authAppRedirectService.logout();
  }
}
